<template>
  <div id="app">
    <tui-image-editor ref="editor" :include-ui="useDefaultUI" :options="options">
    </tui-image-editor>
    <v-btn class="btn__save" color="primary" @click="save" dark> Save </v-btn>
     <v-btn class="btn_close" color="danger" @click="close" dark> Close </v-btn>
  </div>
</template>

<script>
import "tui-image-editor/dist/tui-image-editor.css";
import Loading from "vue-loading-overlay";
import ImageEditor from "@toast-ui/vue-image-editor/src/ImageEditor.vue";
import { bus } from "../../main";
export default {
  name: "imageEditor",
  components: {
    "tui-image-editor": ImageEditor,
  },
  props: ["image", "id"],

  data() {
    return {
      checked_work: "",
     options: {
        includeUI: {
          loadImage: {
            path: this.image,
            name: "Blank",
          },
        },
      },
      src: null,
      useDefaultUI: true,
      // color: "#9734fa",
      //  loaderType: "spinner",
    // isLoading: false,
      // Load:false,
      // for tui-image-editor component's "options" prop
      // cssMaxWidth: 700,
      // cssMaxHeight: 1000
    };
  },

  mounted() {
    var myobj = document.getElementsByClassName(".tui-image-editor-header");
    //  this.loading();
    // console.log("image", image);
  },
  methods: {
    close:function(){
      bus.$emit('closeDialog')
    },
  loading:function(){
      this.Load = true;
      this.$refs.editor.invoke('loadImageFromURL', this.image, 'work image').then(()=>{
      this.Load = false;
    });
    },
    save: function (event) {
      this.src = this.$refs.editor.invoke("toDataURL");
      this.checked_work = this.src;
      axios
        .post(apiRoutes.UploadWork.checked + "/" + this.id, {
          work_image: this.checked_work,
        })
        .then((response) => {
          this.$router.replace({
            name: "APStudents",
          });
          this.loading = false;
        });
      event.preventDefault();
    },
  },
};
</script>

<style>
.tui-image-editor-container {
  position: static;
}
.btn__save {
  position: absolute;
  top: 3%;
  left: 1%;
  width: 100px;
  height: 50px;
  border-radius: 50px;
}
.btn_close{
      position: absolute;
    top: 3%;
    right: 1%;
    width: 100px;
   
    height: 42px;
    border-radius: 50px;
}
@media only screen and (max-width: 600px) {
  .btn__save {
  position: absolute;
  top: 8%;
  left: 1%;
  width: 100px;
  height: 50px;
  border-radius: 50px;
}
.btn_close{
      position: absolute;
  top: 8%;
    right: 1%;
    width: 100px;
   
    height: 42px;
    border-radius: 50px;
}
}
.tui-image-editor-header {
  display: block;
}
.tui-image-editor-container .tui-image-editor-header-logo {
  display: none;
}
.tui-image-editor-container .color-picker-control .tui-colorpicker-palette-button {
  padding: 5px 5px;
}
.tui-image-editor-container .color-picker-control {
  width: 100%;
}
.tui-image-editor-container .tui-image-editor-header-buttons button {
  display: none !important;
}
.tui-image-editor-container
  .tui-image-editor-header-buttons.tui-image-editor-container
  .tui-image-editor-header-buttons {
  display: none !important;
}
.tui-image-editor-container .tui-image-editor-header-buttons,
.tui-image-editor-container .tui-image-editor-controls-buttons {
  display: none !important;
}
</style>
